module.exports = __webpack_public_path__ + "img/failed-qr.65af663f.jpg";